import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, Clock, Globe } from 'lucide-react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-navy-900 text-white pt-20 pb-20 overflow-hidden" data-id="element-63">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#f59e0b 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-64"></div>

      {/* Gold glow */}
      <div className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-gold-500/20 rounded-full blur-[120px] pointer-events-none" data-id="element-65"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-66">
        <div className="grid lg:grid-cols-2 gap-12 lg:items-center max-w-7xl mx-auto" data-id="element-67">
          {/* Headline block — first on mobile, top-left on desktop */}
          <div className="text-center lg:text-left order-1 lg:order-1" data-id="element-68">
            <FadeIn data-id="element-69">
              <div className="inline-block bg-navy-800 border border-navy-700 rounded-full px-4 py-1.5 text-sm font-medium text-gold-400 mb-6" data-id="element-70">
                El sistema más completo para pasar de principiante a profesional
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-71">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight mb-6" data-id="element-72">
                Generá desde{' '}
                <span className="text-gold-500" data-id="element-73">USD 7.000 a 15.000</span> al mes
                navegando por el mundo
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-74">
              <p className="text-lg text-gray-400 max-w-2xl mx-auto lg:mx-0 lg:mb-10" data-id="element-75">
                Lo que hoy es un hobby podría convertirse en tu profesión.
              </p>
            </FadeIn>

            {/* CTA + trust badges — visible only on desktop here */}
            <div className="hidden lg:block" data-id="element-76">
              <FadeIn delay={0.3} data-id="element-77">
                <Button size="xl" onClick={scrollToPricing} className="w-full sm:w-auto mb-10" data-id="element-78">
                  👉 Quiero acceso inmediato
                </Button>
              </FadeIn>

              <FadeIn delay={0.4} data-id="element-79">
                <div className="flex flex-wrap justify-start items-center gap-4 sm:gap-6 text-sm text-gray-400" data-id="element-80">
                  <div className="flex items-center gap-2" data-id="element-81">
                    <Shield className="w-4 h-4 text-gold-500" data-id="element-82" />
                    <span data-id="element-83">Pago 100% seguro</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-84">
                    <Zap className="w-4 h-4 text-gold-500" data-id="element-85" />
                    <span data-id="element-86">Acceso inmediato</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-87">
                    <Clock className="w-4 h-4 text-gold-500" data-id="element-88" />
                    <span data-id="element-89">Garantía 7 días</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-90">
                    <Globe className="w-4 h-4 text-gold-500" data-id="element-91" />
                    <span data-id="element-92">Acceso de por vida</span>
                  </div>
                </div>
              </FadeIn>
            </div>
          </div>

          {/* Product mockup — after headline on mobile, right column on desktop */}
          <FadeIn delay={0.2} className="order-2 lg:order-2 mt-4 lg:mt-0" data-id="element-93">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} className="relative" data-id="element-94">
              <motion.img src="https://cdn.magicpatterns.com/uploads/wxnSipBSy874183rdXnBTL/Untitled_design.png" alt="Cómo convertirte en Capitán Internacional — Sistema completo con libro, certificaciones y plan de carrera" className="relative z-10 w-full max-w-xl mx-auto drop-shadow-2xl" animate={{
              y: [0, -12, 0]
            }} transition={{
              duration: 5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-95" />
            </motion.div>
          </FadeIn>

          {/* CTA + trust badges on MOBILE — appears after image */}
          <div className="order-3 lg:hidden text-center" data-id="element-96">
            <FadeIn delay={0.3} data-id="element-97">
              <Button size="xl" onClick={scrollToPricing} className="w-full sm:w-auto mb-10" data-id="element-98">
                👉 Quiero acceso inmediato
              </Button>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-99">
              <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 text-sm text-gray-400" data-id="element-100">
                <div className="flex items-center gap-2" data-id="element-101">
                  <Shield className="w-4 h-4 text-gold-500" data-id="element-102" />
                  <span data-id="element-103">Pago 100% seguro</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-104">
                  <Zap className="w-4 h-4 text-gold-500" data-id="element-105" />
                  <span data-id="element-106">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-107">
                  <Clock className="w-4 h-4 text-gold-500" data-id="element-108" />
                  <span data-id="element-109">Garantía 7 días</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-110">
                  <Globe className="w-4 h-4 text-gold-500" data-id="element-111" />
                  <span data-id="element-112">Acceso de por vida</span>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}